module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C358"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("THE WORLD")])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "C359"
  }, [_vm._v("Key locations visited in the book are labelled below in CAPITALS.")]), _vm._v(" "), _c('p', {
    staticClass: "C251"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "html/images/14_1.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-259e624b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/07_The_World__key_locations_visited.vue
// module id = 75
// module chunks = 0